"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconHydrogen = function IconHydrogen(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M6 10a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4zm4-2h28a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2m20.784 21.828a2.2 2.2 0 0 0 .998-1.743c0-.736-.397-1.27-1.107-1.499-.562-.181-1.192-.242-1.747-.044a1.9 1.9 0 0 0-.647.396c-.402.388-.61.924-.551 1.475h1.49a.5.5 0 0 1 .134-.402.58.58 0 0 1 .402-.164c.12 0 .238.03.328.104.09.09.134.194.134.328 0 .358-.313.64-.61.909l-.03.03-1.729 1.49v1.236h3.993v-1.356h-1.967zM19.6 18H18v10.4h1.6V24h5.088v4.4h1.6V18h-1.6v4.464H19.6z",
    clipRule: "evenodd"
  })));
};

export { IconHydrogen, IconHydrogen as default };
